/**
 * Импорт `*.svg` из webpack обычно даёт строку URL; в тестах/моках тип может отличаться.
 */
export function resolveStaticImportUrl(imported: unknown): string {
  if (typeof imported === 'string') {
    return imported;
  }

  if (imported != null && typeof imported === 'object' && 'default' in imported) {
    const inner = (imported as { default: unknown }).default;
    if (typeof inner === 'string') {
      return inner;
    }
  }

  return '';
}
